export enum SubscriptionNameEnum {
  PROFESSIONAL = 'professional',
  ENTERPRISE = 'enterprise'
}

export enum SubscriptionDiscountUnitEnum {
  MONTH = 'month',
  SCREEN = 'screen',
  PERCENT = 'percent',
  AMOUNT = 'amount'
}
